// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"28ee41a6","455":"7d30ada0"}[chunkId] + ".chunk.js";
};